
export const ForecastMethodSection = ({
    method,
    setMethod
}) => {
    return (
        <div className="space-y-3">
            <label className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70">
                Forecast Method
            </label>
            <div className="flex items-center gap-2 justify-start">
                <button 
                    className={`${method === "ad-spend" ? "border-blue-300 text-blue-900 bg-blue-100" : ""} inline-flex items-center border border-gray-300 justify-center rounded-md text-sm font-medium transition-colors h-10 px-3`}
                    onClick={() => setMethod?.("ad-spend")}
                >
                    Ad Spend × MER
                </button>
                <button 
                    className={`${method === "revenue" ? "border-green-300 text-green-900 bg-green-100" : ""} inline-flex items-center border border-gray-300 justify-center rounded-md text-sm font-medium transition-colors h-10 px-3`}
                    onClick={() => setMethod?.("revenue")}
                >
                    Manual Revenue Target
                </button>
            </div>
        </div>
    )
}